import { render, staticRenderFns } from "./account-shop.vue?vue&type=template&id=296208e9&scoped=true&"
import script from "./account-shop.vue?vue&type=script&lang=js&"
export * from "./account-shop.vue?vue&type=script&lang=js&"
import style0 from "./account-shop.vue?vue&type=style&index=0&id=296208e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296208e9",
  null
  
)

export default component.exports